/*
 * @Author: Json Chen
 * @Date: 2021-06-30 10:35:04
 * @LastEditTime: 2022-06-13 15:03:16
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLanguage/Components/AvailableLanguagesTable.tsx
 */

import { Button } from '@/src/components/Antd';
import DroppableTable from 'src/components/DroppableTable/EditDraggableTable';
import ModalDelHOC from '@/src/constrains/ModalDelHOC';
import React from 'react';
import styles from '../style.module.less';
import AvailableLanguagesModalForm from './AvailableLanguagesModalForm';
import { TableInput } from 'src/components/EditableTable/TableForm1';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
const TIPCONTENTSTRATEGY = {
  confirm: {
    title: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.confirmtitle'),
    content: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.confirmcontent'),
    buttonType: 'primary',
    okText: getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm'),
  },
  delete: {
    title: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.deletetitle'),
    content: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.deletecontent'),
    buttonType: 'danger',
    okText: getI18nFromGeneral('general.antd.Modal.ModalFooter.delete'),
  },
};
const AvailableLanguagesTable = ({
  value: availableLanguages = [],
  onCustomChange: onChange,
  onChange: _onChange,
  onDelClick,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const _availableLanguages = availableLanguages;
  const primaryLanguage = availableLanguages.find((i) => i.primary);
  const primaryTag = get(primaryLanguage, 'tag');
  const availabilityConfig = React.useMemo(() => {
    if (primaryTag) {
      return {
        [primaryTag]: {
          disableDrag: true,
          hideDragger: false,
        },
      };
    }
    return {};

    // return availableLanguages.reduce((pre, i) => {
    //   const { primary, tag } = i;
    //   if (primary) {
    //     return {
    //       ...pre,
    //       [tag]: {
    //         disableDrag: true,
    //         hideDragger: false,
    //       },
    //     };
    //   }
    //   return {
    //     ...pre,
    //     [tag]: {
    //       disableDrag: false,
    //       hideDragger: false,
    //     },
    //   };
    // }, {});
  }, [primaryTag]);
  // .map((item, index) => ({
  //   ...item,
  //   // primary = true 的,不可拖拽
  //   dragable: !item.primary,
  // }));

  const [formModalVisible, setFormModalVisible] =
    React.useState<boolean>(false);
  const availableLanguagesColumns = React.useMemo(() => {
    return [
      {
        title: getI18n('salesChannelLanguage.index.language'),
        key: 'description',
        dataIndex: 'description',
        default: true,
        width: 448,
        textWrap: 'word-break',
        childGenerate: (text, record, index) => {
          return <div className={styles.tb}>{text}</div>;
        },
      },
      {
        title: getI18n('salesChannelLanguage.index.languageTag'),
        key: 'tag',
        dataIndex: 'tag',
        default: true,
        width: 224,
        textWrap: 'word-break',
        childGenerate: (text: string) => {
          return <div className={styles.tb}>{text}</div>;
        },
      },
      {
        title: (
          <span>
            {getI18n('salesChannelLanguage.index.nativeLanguageName')}
            <EditIcon />
          </span>
        ),
        key: 'name',
        dataIndex: 'name',
        default: true,
        width: 224,
        textWrap: 'word-break',
        childGenerate: (text: string, record, index) => {
          const { tag } = record;
          return (
            <TableInput
              className={styles.tb}
              value={text}
              onChange={(e) => {
                const availableLanguages = [..._availableLanguages];
                (availableLanguages[index] || {}).name = e;
                _onChange(availableLanguages);
              }}
              label={text}
              onBlurCallback={(cb) => {
                if (!text) {
                  const availableLanguages = [..._availableLanguages];
                  (availableLanguages[index] || {}).name = tag;
                  _onChange(availableLanguages);
                }
                if (cb) {
                  cb();
                }
              }}
            />
          );
        },
      },
      disableEdit
        ? {}
        : {
            title: getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
            default: true,
            optional: true,
            align: 'center',
            width: 192,
            childGenerate: (_, record, index) => {
              return (
                <div className={styles.action}>
                  <span
                    className={styles.danger}
                    onClick={() => onDelClick(index)}>
                    {getI18n('general.delete')}
                  </span>
                </div>
              );
            },
          },
    ];
  }, [_availableLanguages]);

  const showFormModal = () => {
    setFormModalVisible(true);
  };

  const onTableChange = (data) => {
    onChange(data, 'SORT');
  };

  const hideFormModal = () => {
    setFormModalVisible(false);
  };
  const onFormModalConfirm = (data) => {
    const _data = availableLanguages.concat({
      ...data,
      tag: data.languageTag,
    });
    onChange(_data, 'ADD');

    hideFormModal();
  };

  return (
    <div className={styles.tableAvailableLanguage}>
      <DroppableTable
        id='LanguageSetting'
        rowKey={'tag'}
        className={styles.table}
        dataSource={_availableLanguages}
        columns={availableLanguagesColumns}
        onTableChange={onTableChange}
        pagination={false}
        hideAllDragHandlers={disableEdit}
        availabilityConfig={availabilityConfig}
      />
      <Button type='primary' onClick={showFormModal} disabled={disableEdit}>
        {getI18n('salesChannelLanguage.index.addAvailableLanguage')}
      </Button>
      <AvailableLanguagesModalForm
        visible={formModalVisible}
        onCancel={hideFormModal}
        onModalConfirm={onFormModalConfirm}
        availableLanguages={availableLanguages}
      />
    </div>
  );
};

export default ModalDelHOC(AvailableLanguagesTable, {
  modalDataStrategy: TIPCONTENTSTRATEGY,
  canDel: ({ list, index }) => {
    // primary 为true 则不能被删除
    return !list[index].primary;
  },
});
